import React, { forwardRef } from 'react';

import { Box, useTheme } from '@mui/material';
import PhoneInput, { parsePhoneNumber } from 'react-phone-number-input';

import { CrossSmallIcon } from '@setup/svg-icons/svg-icons';

import PhoneNumberCustom from './PhoneNumberCustom';

import './sytle.scss';
import type { E164Number } from 'libphonenumber-js/core';

export type MuiPhoneNumberTextProps = {
  isDisabled?: boolean;
  isRequired?: boolean;
  isReadOnly?: boolean;
  isFullWidth?: boolean;
  isError?: boolean;
  label?: string;
  placeholder?: string;
  value?: E164Number | undefined;
  helperText?: string;
  defaultCountry?: string;
  errorMessage?: string;
  inputVariant?: 'outline' | 'text';
  isToUpperCase?: boolean;
  onChange: (values?: string, country?: string) => void;
  size?: 'small' | 'medium';
  [x: string]: any;
};

export const MuiPhoneNumberTextFiled = forwardRef<HTMLHeadingElement, MuiPhoneNumberTextProps>(
  (props, ref) => {
    const theme = useTheme();

    const {
      isDisabled,
      isError,
      isFullWidth = true,
      isRequired,
      isReadOnly,
      inputVariant,
      isToUpperCase = false,
      label,
      placeholder,
      helperText,
      errorMessage,
      value,
      onChange,
      size = 'medium',
      ...args
    } = props;

    const handleClearValue = (e: any) => {
      e.preventDefault();
      e.stopPropagation();
      onChange?.('', '');
    };
    return (
      <PhoneInput
        {...args}
        defaultCountry="US"
        className={
          label
            ? ''
            : inputVariant === 'text'
              ? 'phone-number-input_text'
              : 'phone-number-input_without-label'
        }
        inputRef={ref}
        international
        label={isToUpperCase ? label?.toUpperCase() : label}
        errorMessage={errorMessage}
        fullWidth={isFullWidth}
        isDisabled={isDisabled}
        isRequired={isRequired}
        value={value}
        numberInputProps={{ ref }}
        isError={isError}
        placeholder={placeholder}
        helperText={helperText}
        size={size}
        inputVariant={inputVariant}
        isReadOnly={isReadOnly}
        onChange={(phone) => {
          const country = phone ? parsePhoneNumber(phone)?.country : '';
          return phone ? onChange(phone, country) : onChange('', '');
        }}
        endAdornment={
          value ? (
            <Box
              onClick={handleClearValue}
              sx={{
                display: 'flex',
                alignItems: 'center',
                position: 'relative',
                zIndex: '100',
                width: '16px',
                height: '16px',
                cursor: 'pointer !important',
                color: `${
                  isDisabled ? theme.palette.case.neutral.n500 : theme.palette.case.neutral.n700
                } !important`,

                svg: {
                  path: { fill: 'currentcolor' },
                },

                '&:hover': {
                  opacity: '0.7',
                },
              }}
            >
              <CrossSmallIcon />
            </Box>
          ) : null
        }
        inputComponent={PhoneNumberCustom}
        isFullWidth={isFullWidth}
      />
    );
  },
);

export default MuiPhoneNumberTextFiled;
